var _path, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7068 17.3222C12.8257 17.1875 11.0958 16.2424 9.96618 14.7322C9.60781 14.2531 9.70568 13.5742 10.1848 13.2158C10.6639 12.8574 11.3428 12.9553 11.7012 13.4344C12.4543 14.4412 13.6075 15.0713 14.8616 15.1611C16.1157 15.2509 17.347 14.7916 18.236 13.9023L21.4728 10.6657C23.115 8.96538 23.0915 6.26266 21.42 4.59114C19.7485 2.91963 17.0458 2.89615 15.3566 4.52739L13.4933 6.37989C13.069 6.80172 12.3831 6.79972 11.9612 6.37543C11.5394 5.95113 11.5414 5.2652 11.9657 4.84337L13.8402 2.9799C16.3907 0.516582 20.4448 0.551811 22.9521 3.05908C25.4593 5.56635 25.4946 9.62044 23.018 12.1843L19.7682 15.4342C18.4349 16.768 16.588 17.4569 14.7068 17.3222ZM11.2938 8.67773C13.1749 8.81245 14.9048 9.75756 16.0345 11.2678C16.3928 11.7469 16.295 12.4258 15.8159 12.7841C15.3368 13.1425 14.6578 13.0447 14.2995 12.5655C13.5464 11.5587 12.3931 10.9287 11.139 10.8389C9.88496 10.749 8.65369 11.2083 7.76467 12.0977L4.52787 15.3343C2.88565 17.0346 2.90914 19.7373 4.58065 21.4088C6.25217 23.0803 8.95489 23.1038 10.6418 21.4748L12.4943 19.6223C12.9173 19.1992 13.6033 19.1992 14.0263 19.6223C14.4494 20.0454 14.4494 20.7313 14.0263 21.1544L12.1604 23.02C9.60995 25.4834 5.55586 25.4481 3.04859 22.9409C0.541318 20.4336 0.506089 16.3795 2.98261 13.8156L6.23247 10.5658C7.56579 9.23195 9.41269 8.543 11.2938 8.67773Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7068 17.3222C12.8257 17.1875 11.0958 16.2424 9.96618 14.7322C9.60781 14.2531 9.70568 13.5742 10.1848 13.2158C10.6639 12.8574 11.3428 12.9553 11.7012 13.4344C12.4543 14.4412 13.6075 15.0713 14.8616 15.1611C16.1157 15.2509 17.347 14.7916 18.236 13.9023L21.4728 10.6657C23.115 8.96538 23.0915 6.26266 21.42 4.59114C19.7485 2.91963 17.0458 2.89615 15.3566 4.52739L13.4933 6.37989C13.069 6.80172 12.3831 6.79972 11.9612 6.37543C11.5394 5.95113 11.5414 5.2652 11.9657 4.84337L13.8402 2.9799C16.3907 0.516582 20.4448 0.551811 22.9521 3.05908C25.4593 5.56635 25.4946 9.62044 23.018 12.1843L19.7682 15.4342C18.4349 16.768 16.588 17.4569 14.7068 17.3222ZM11.2938 8.67773C13.1749 8.81245 14.9048 9.75756 16.0345 11.2678C16.3928 11.7469 16.295 12.4258 15.8159 12.7841C15.3368 13.1425 14.6578 13.0447 14.2995 12.5655C13.5464 11.5587 12.3931 10.9287 11.139 10.8389C9.88496 10.749 8.65369 11.2083 7.76467 12.0977L4.52787 15.3343C2.88565 17.0346 2.90914 19.7373 4.58065 21.4088C6.25217 23.0803 8.95489 23.1038 10.6418 21.4748L12.4943 19.6223C12.9173 19.1992 13.6033 19.1992 14.0263 19.6223C14.4494 20.0454 14.4494 20.7313 14.0263 21.1544L12.1604 23.02C9.60995 25.4834 5.55586 25.4481 3.04859 22.9409C0.541318 20.4336 0.506089 16.3795 2.98261 13.8156L6.23247 10.5658C7.56579 9.23195 9.41269 8.543 11.2938 8.67773Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.14694,
    y1: 12.9997,
    x2: 24.8541,
    y2: 12.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D43F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.000495025,
    y1: 12.9998,
    x2: 26,
    y2: 12.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    stopColor: "#57D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D43F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGrad);
export default __webpack_public_path__ + "static/media/LinkGrad.66aec3ab8c479eb7927836a14f8e4c20.svg";
export { ForwardRef as ReactComponent };